import React, { useEffect, useState } from "react";
import { Alert } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { connect } from "react-redux";
import { addUserSettingsLoad } from "../../../appRedux/ducks/userSettings";
import "./AutoTradingAlert.scss";

/**
 * Reusable alert component for auto trading notification
 * Only displays once - will be hidden after user closes it
 */
const AutoTradingAlert = ({
  showAutoPortfolioIndicators,
  userSettings,
  setUserSettings,
  broker = "Orion", // Default broker name can be overridden
}) => {
  const [showAlert, setShowAlert] = useState(false);

  // Check if we should show the alert based on user settings and auto portfolio status
  useEffect(() => {
    const shouldShowAlert =
      showAutoPortfolioIndicators && !userSettings.autoAlertClosed;
    setShowAlert(shouldShowAlert);
  }, [showAutoPortfolioIndicators, userSettings.autoAlertClosed]);

  // Handle closing the alert and update user settings
  const handleClose = () => {
    setShowAlert(false);

    // Update user settings to remember the alert was closed
    setUserSettings({
      ...userSettings,
      autoAlertClosed: true,
    });
  };

  if (!showAlert) return null;

  return (
    <Alert
      severity="info"
      icon={<InfoIcon />}
      className="auto-trading-alert"
      onClose={handleClose}
    >
      <div className="banner-content">
        <div className="banner-title">
          View your portfolio performance or trades accurately on {broker}
        </div>
        <div className="banner-subtitle">
          Additional details on accessing your {broker} account have been sent
          to your email by our RIA
        </div>
      </div>
    </Alert>
  );
};

const stateToProps = (state) => ({
  userSettings: state.userSettings.userSettings,
});

const dispatchToProps = (dispatch) => ({
  setUserSettings: (settings) => dispatch(addUserSettingsLoad(settings)),
});

export default connect(stateToProps, dispatchToProps)(AutoTradingAlert);
